import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedinIn, FaInstagram, FaFacebookF, FaTwitter, FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';
import Logo from './images/FINAL-LOGO-GV.png';
import ScrollToTop from './ScrollToTop';
import WhatsAppBtn from './WhatsAppBtn';
const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/services', label: 'Services' },
    { path: '/blog', label: 'Blog' },
    // { path: '/career', label: 'Career' },
    { path: '/contact', label: 'Contact' }
  ];

  const services = [
    'Strategic Planning',
    'Audience Engagement',
    'Campaign Management',
    'Website Development',
    'SEO & Digital Marketing',
    'Graphic Design',
    'Free Hosting & Support'
  ];

  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 mb-4">
              <Link to="/" aria-label="GrowthVibe Home">
                <img src={Logo} alt="GrowthVibe logo" className="mb-3 img-fluid footer-logo" loading="eager" />
              </Link>
              <p className="mb-3 text-light">
                Elevate Your Brand with Strategic Marketing & IT Solutions.
                We're your growth partner in the digital world.
              </p>
              <div className="social-icons">
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <FaLinkedinIn />
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <FaInstagram />
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <FaFacebookF />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                  <FaTwitter />
                </a>
              </div>
            </div>

            <div className="col-lg-2 col-md-6 mb-4">
              <h5>Quick Links</h5>
              <ul className="list-unstyled">
                {quickLinks.map((link) => (
                  <li key={link.path} className="mb-2">
                    <Link to={link.path}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 mb-4">
              <h5>Our Services</h5>
              <ul className="list-unstyled">
                {services.map((service, index) => (
                  <li key={index} className="mb-2">
                    <Link to="/services">{service}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 mb-4">
              <h5>Contact Info</h5>
              <div className="contact-info">
                <p className="mb-2">
                  <FaEnvelope className="me-2" />
                  <a href="mailto:growthvibe2406@gmail.com">growthvibe2406@gmail.com</a>
                </p>
                <p className="mb-2">
                  <FaPhoneAlt className="me-2" />
                  <a href="tel:+917861083648">+91 78610 83648</a>
                </p>
                <p className="mb-2">
                  <FaMapMarkerAlt className="me-2" />
                  <a href="https://maps.app.goo.gl/8r7tPJNXPRzC4q9i7" target="_blank" rel="noopener noreferrer">Surat, Gujarat</a>
                </p>
              </div>
            </div>
          </div>

          <hr className="my-4" style={{ borderColor: 'rgba(255,255,255,0.1)' }} />

          <div className="align-items-center">
            <div className="col-md-6" style={{width:'100%'}}>
              <p className="mb-0 text-light" style={{textAlign:'center',width:'100%'}}>
                © {currentYear} GrowthVibe. All rights reserved.
              </p>
            </div>
            {/* <div className="col-md-6 text-md-end">
              <p className="mb-0 text-light">
                <Link to="/privacy" className="me-3">Privacy Policy</Link>
                <Link to="/terms">Terms of Service</Link>
              </p>
            </div> */}
          </div>
        </div>
      </footer>
      <ScrollToTop />
      <WhatsAppBtn />
    </>
  );
};

export default Footer;
